<script>
import { CdrImg, CdrList } from '@rei/cedar';
import ProductComponent from '../ProductComponent/ProductComponent.vue';
import ProductReview from '../../models/ProductReview';
import LongFormContent from './LongFormContent.vue';

export default {
  name: 'ProductRecommendationsGendered',
  components: {
    LongFormContent,
    ProductComponent,
    CdrImg,
    CdrList,
  },
  inheritAttrs: false,
  props: {
    authorSpecs: {
      type: Array,
      default: () => [],
    },
    badge: {
      type: String,
      default: '',
    },
    bottomLine: {
      type: String,
      default: '',
    },
    headerId: {
      type: String,
      default: null,
    },
    inlineImage: {
      type: String,
      default: null,
    },
    mainImageAlt: {
      type: String,
      default: '',
      required: true,
    },
    name: {
      type: String,
      default: '',
      required: true,
    },
    reviewIntro: {
      type: Object,
      default: null,
    },
    tagline: {
      type: String,
      default: '',
    },
    testingNotes: {
      type: Array,
      default: () => [],
    },
    firstProduct: {
      type: Object,
      default: () => ({
        link: '',
        mainImage: '',
        mainImageAlt: '',
        lowestPrice: 0,
        highestPrice: 0,
        averageRating: 0,
        reviewCount: 0,
        available: true,
        gender: '',
        genderedOutOfStockText: '',
      }),
      required: true,
    },
    secondProduct: {
      type: Object,
      default: () => ({
        link: '',
        mainImage: '',
        mainImageAlt: '',
        lowestPrice: 0,
        highestPrice: 0,
        averageRating: 0,
        reviewCount: 0,
        available: true,
        gender: '',
        genderedOutOfStockText: '',
      }),
      required: true,
    },
  },
  computed: {
    combinedSpecs() {
      return this.authorSpecs.map((spec) => {
        let lineItem = spec;
        const specItems = spec.split(':');
        if (specItems[0] && specItems[1]) {
          lineItem = `<strong>${specItems[0]}</strong>${specItems[1]}`;
        }
        return `<p>${lineItem}</p>`;
      }).join('');
    },
    productReview() {
      return new ProductReview({
        editorsChoice: !!this.badge,
        tagline: this.tagline,
        productName: this.name,
        productSpecs: this.combinedSpecs,
      }, [this.firstProduct, this.secondProduct]);
    },
    checkForContentReviewIntro() {
      // for productcomponents that don't have review information, an empty paragraph
      // tag is inserted. check for this empty tag and don't build the review paragraph
      return !!(this.reviewIntro && Object.hasOwn(this.reviewIntro, 'children') && !(this.reviewIntro.children[0].children[0].text === ''));
    },
  },
};
</script>
<template>
  <section class="ea_img-responsive">
    <product-component
      class="product-component-gendered"
      :is-editors-choice="productReview.isEditorsChoice"
      :header="productReview.tagline"
      :subheader="productReview.productName"
      :spec-list="productReview.productSpecs"
      :first-product="productReview.productPrimary"
      :second-product="productReview.productSecondary"
      :bookmark-id="headerId"
    />
    <article
      v-if="checkForContentReviewIntro || inlineImage || bottomLine || testingNotes"
      class="html-wysiwyg-content"
      data-ui="section-review-information"
    >
      <long-form-content
        v-if="checkForContentReviewIntro"
        add-paragraph-label="Test Results:"
        :json-content="reviewIntro"
        data-ui="test-results-paragraph"
      />
      <cdr-img
        v-if="inlineImage"
        class="image_editors ea_img-responsive"
        :src="inlineImage"
        :alt="mainImageAlt"
        loading="lazy"
        data-ui="inline-image"
      />
      <blockquote
        v-if="bottomLine"
        data-ui="bottomline-blockquote"
      >
        Bottom Line: {{ bottomLine }}
      </blockquote>
      <template v-if="testingNotes">
        <h3 data-ui="testingNotes-header">
          Testing Stats:
        </h3>
        <cdr-list tag="ul">
          <li
            v-for="(note, index) in testingNotes"
            :key="index"
            data-ui="testingNotes-list"
          >
            <strong>{{ note.note }}:</strong> {{ note.description }}
          </li>
        </cdr-list>
      </template>
    </article>
  </section>
</template>
<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

</style>
